import React, { useCallback, useState, useEffect } from 'react';
import FeedbackCTA from '@boschebike/ebds-react/dist-esm/components/WebGenericFeedbackCTA.js';

const dispatchFeedback = async (product, productId, team, source) => {
  try {
    const user = await dodo.user.getData();
    const { userType } = user;
    dodo.ui.dispatchModal({
      type: 'feedback',
      props: {
        product,
        productId,
        team,
        source,
        userType,
      },
    });
  } catch (error) {
    console.error(error);
  }
};
/**
 * @typedef {import('../../App.d.ts').ComponentFeedbackCTA} ComponentFeedbackCTA
 */
/**
 * @param {ComponentFeedbackCTA} props
 * @returns {React.js.Element}
 * @constructor
 */
export default ({
  product,
  productId,
  team,
  source,
}) => {
  const [client, setClient] = useState(false);

  useEffect(() => {
    setClient(true);
  }, []);

  const handleOpen = useCallback(() => {
    dispatchFeedback(product, productId, team, source);
  }, [
    product,
    productId,
    team,
    source,
  ]);

  if (!client) {
    return null;
  }

  return (
    <FeedbackCTA
      product={product}
      productId={productId}
      team={team}
      source={source}
      onDispatchModal={handleOpen}
      customImporter={() => {}}
    />
  );
};
